/**
 * Product ad target lengths — keep in sync with /shared/product-ad-durations.js
 */

export const PRODUCT_AD_DURATION_OPTIONS = [10, 15, 20, 30, 40, 50, 60];

export const PRODUCT_AD_DEFAULT_DURATION_SEC = 30;

export const PRODUCT_AD_MIN_DURATION_SEC = 10;

export const PRODUCT_AD_MAX_DURATION_SEC = 60;

export function normalizeProductAdDurationSec(raw) {
  const n = Math.round(Number(raw));
  if (PRODUCT_AD_DURATION_OPTIONS.includes(n)) return n;

  const fallback =
    Number.isFinite(n) && n > 0 ? n : PRODUCT_AD_DEFAULT_DURATION_SEC;
  const clamped = Math.min(
    PRODUCT_AD_MAX_DURATION_SEC,
    Math.max(PRODUCT_AD_MIN_DURATION_SEC, fallback),
  );

  let best = PRODUCT_AD_DEFAULT_DURATION_SEC;
  let bestDist = Infinity;
  for (const opt of PRODUCT_AD_DURATION_OPTIONS) {
    const d = Math.abs(opt - clamped);
    if (d < bestDist) {
      bestDist = d;
      best = opt;
    }
  }
  return best;
}
